<template>
  <svg
    width="991"
    height="1021"
    viewBox="0 0 991 1021"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_8008_12755)">
      <ellipse
        cx="88.3003"
        cy="118.621"
        rx="88.3003"
        ry="118.621"
        transform="matrix(-0.866025 0.5 0.5 0.866025 512.94 364)"
        fill="#A370F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_8008_12755"
        x="0.790863"
        y="0.825897"
        width="989.98"
        height="1020.11"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="199.105"
          result="effect1_foregroundBlur_8008_12755"
        />
      </filter>
    </defs>
  </svg>
</template>
